import React, { useRef } from 'react';

import { useToggle, useCollapsible } from '../../hooks';
import { classNames } from '../../utils/css';

import MobileMenuLink from './mobileMenuLink';

const MobileMenuCollapse = ({
  label,
  data,
}) => {
  const [expanded, toogleExpanded] = useToggle(false);

  const contentRef = useRef(null);

  const { heightContent } = useCollapsible({ contentRef, expanded });

  return (
    <div className="mobile_menu__tab__panel__collapse">
      <button
        type="button"
        onClick={() => toogleExpanded()}
        className={classNames(
          "mobile_menu__tab__panel__collapse__btn",
          {
            "mobile_menu__tab__panel__collapse__open": expanded,
          },
        )}
      >
        <span>{label}</span>

        <span
          className="mobile_menu__tab__panel__collapse__btn__arrow"
        >
          ▸
        </span>
      </button>

      <div
        className={classNames(
          "mobile_menu__tab__panel__collapse__content",
          {
            "mobile_menu__tab__panel__collapse__open": expanded,
          },
        )}
        style={{ height: heightContent }}
      >
        <div ref={contentRef}>
          {data.map(({ title, path }) => (
            <div
              key={`mobile-menu-tabs-panel-${label}-list-collapse-${title}`}
              className={classNames(
                "mobile_menu__tab__panel__item",
                "mobile_menu__tab__panel__item__no_border_last",
              )}
            >
              <MobileMenuLink title={title} path={path} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileMenuCollapse;
